<template>
  <div style="background-color: #1e1e2f" id="">
    <div class="pad" style="background-color: #1e1e2f">
      <div class="dial-pad">
        <div class="contact">
          <div class="avatar"
            style="background-image: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/378978/profile/profile-80_1.jpg');">
          </div>
          <div class="contact-info"></div>
        </div>
        <div class="phoneString" style="margin-top: 10px">
          <h3 style="padding-top: 10px">{{ concateInput }}</h3>
        </div>
        <div class="digits">
          <div class="dig pound number-dig" name="1" @click="digitPressed('1')">
            1
          </div>
          <div class="dig number-dig" name="2" @click="digitPressed('2')">
            2
            <div class="sub-dig">ABC</div>
          </div>
          <div class="dig number-dig" name="3" @click="digitPressed('3')">
            3
            <div class="sub-dig">DEF</div>
          </div>
          <div class="dig number-dig" name="4" @click="digitPressed('4')">
            4
            <div class="sub-dig">GHI</div>
          </div>
          <div class="dig number-dig" name="5" @click="digitPressed('5')">
            5
            <div class="sub-dig">JKL</div>
          </div>
          <div class="dig number-dig" name="6" @click="digitPressed('6')">
            6
            <div class="sub-dig">MNO</div>
          </div>
          <div class="dig number-dig" name="7" @click="digitPressed('7')">
            7
            <div class="sub-dig">PQRS</div>
          </div>
          <div class="dig number-dig" name="8" @click="digitPressed('8')">
            8
            <div class="sub-dig">TUV</div>
          </div>
          <div class="dig number-dig" name="9" @click="digitPressed('9')">
            9
            <div class="sub-dig">WXYZ</div>
          </div>
          <div class="dig number-dig astrisk" name="*" @click="digitPressed('*')">
            *
          </div>
          <div class="dig number-dig pound" name="0" @click="digitPressed('0')">
            0
          </div>
          <div class="dig number-dig pound" name="#" @click="digitPressed('#')">
            #
          </div>
        </div>
        <div class="digits">
          <router-link :to="`${homeUrl}`" class="dig addPerson action-dig">
            <i class="fa fa-home" style="margin-top: 5px"></i>
          </router-link>
          <div class="dig-spacer"></div>
          <div class="dig goBack action-dig" @click="digitDeleted()">
            <i class="fa fa-arrow-left" style="margin-top: 12px"></i>
          </div>
        </div>
      </div>

      <div class="call action-dig" @click="dial()">
        <!-- <div class="call-change"><span>
      <i class="ti-arrow-left"></i>
      </span></div> -->
        <div class="call-icon" style="margin-top: 12px">
          <i class="fa fa-phone"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/shared/emulatorApi";
import menuApi from "@/shared/menuApi";
import { format } from 'date-fns';


export default {
  components: {},
  name: "DialPad",
  props: {
    homeUrl: "",
  },
  data() {
    return {
      retdata: {},
      keyinput: [],
      currentApp: {},
      LogsResponse:[],
      error: "",
    };
  },
  computed: {
    concateInput() {
      return this.keyinput.join("");
    },
  },
  methods: {
    digitPressed(digit) {
      this.keyinput.push(digit);
    },
    digitDeleted() {
      if (this.keyinput.length) this.keyinput.pop();
    },
    async dial() {
      const data = {
        input: this.keyinput.join(""),
      };
      let sessionId = format(new Date(), 'yyyyMMddHHmmss');
      this.$store.commit("setCurrentSessionId", sessionId);
      this.$store.getters.getCurrentApp;
      const dialingNumber = this.$store.getters.getDialingPhone;;
      let response = await api.initiate(data.input, this.currentApp.appId,sessionId,dialingNumber);
      console.log("Initiate response >>>", JSON.stringify(response));
      this.$emit("numberDialed", response);
    },
  },
  async mounted() {
    let app = this.$store.getters.getCurrentApp;
    //console.log("The current app is>>>", app);
    if (app == null || app.appId == null) {
      //console.log("The route params id " + this.$route.params.appId);
      let response = await menuApi.getAppById(this.$route.params.appId);
      //console.log('The app is >>>',response);
      if (response.status == "00") {
        app = response.data;
      }
    }
    if (app && app.appId) {
      for (let k = 0; k < app.shortCode.length; k++) {
        this.keyinput.push(app.shortCode[k]);
      }
    }
    this.currentApp = app;
    if (this.homeUrl === "") {
      this.homeUrl = `/app/design/${this.currentApp.appId}`;
    }

  },
};
</script>

<style lang="css" scoped>
.pad {
  width: 400px;
  height: 700px;
  background-color: #232323;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  box-shadow: 0 30px 35px -25px black;
  animation: showPad 1s ease forwards 1;
  border-radius: 8px;
}

.pad .dial-pad .contact {
  width: 60%;
  position: relative;
  margin-left: 20%;
  margin-top: 40px;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.pad .dial-pad .contact.showContact {
  opacity: 1;
}

.pad .dial-pad .contact .avatar {
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center center;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  box-shadow: 0 15px 30px -10px black;
  position: absolute;
  left: 0px;
  top: 8px;
}

.pad .dial-pad .contact .contact-info {
  border-radius: 8px;
  width: 85%;
  margin-left: 15%;
  background-color: #2d2d2d;
  height: 76px;
  overflow: hidden;
}

.pad .dial-pad .contact .contact-info>div {
  width: 80%;
  margin-left: 20%;
  font-size: 12px;
  margin-top: 3px;
}

.pad .dial-pad .contact .contact-info .contact-name {
  color: #fdfdfd;
  margin-top: 12px;
}

.pad .dial-pad .contact .contact-info .contact-position {
  font-style: italic;
  color: #aeaeae;
}

.pad .dial-pad .contact .contact-info .contact-number {
  color: white;
}

.pad .dial-pad .contact .contact-info .contact-number span {
  color: #3de066;
  display: inline;
}

.pad .dial-pad .contact .contact-buttons {
  position: absolute;
  right: -5px;
  top: 0px;
  width: 40px;
  height: 76px;
}

.pad .dial-pad .contact .contact-buttons button {
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  box-shadow: 0 12px 25px -5px black;
  display: block;
  position: absolute;
  right: 0px;
  background-size: 75% auto;
  background-position: center center;
  background-repeat: no-repeat;
}

.pad .dial-pad .contact .contact-buttons button:focus {
  outline: none;
}

.pad .dial-pad .contact .contact-buttons button.icon-message {
  background-color: #ffc44e;
  top: 5px;
}

.pad .dial-pad .contact .contact-buttons button.icon-video {
  background-color: #a529f9;
  bottom: 5px;
}

.pad .dial-pad .phoneString {
  text-align: center;
  width: 100%;
  height: 80px;
  background-color: #2d2d2d;
  margin-top: 40px;
}

.pad .dial-pad .phoneString input {
  text-align: center;
  background-color: transparent;
  width: 60%;
  margin-left: 20%;
  height: 80px;
  border: none;
  font-size: 30px;
  color: white;
  font-weight: 700;
  letter-spacing: 2px;
}

.pad .dial-pad .phoneString input:focus {
  outline: none;
}

.pad .dial-pad .digits {
  overflow: hidden;
  width: 60%;
  margin-left: 20%;
  margin-top: 20px;
}

.pad .dial-pad .digits .dig-spacer {
  width: 60px;
  margin: 10px calc(50% - 90px);
  float: left;
}

.pad .dial-pad .digits .dig {
  color: white;
  font-size: 30px;
  float: left;
  background-color: #2d2d2d;
  text-align: center;
  width: 60px;
  height: 56px;
  border-radius: 100%;
  margin: 10px 0px;
  padding-top: 4px;
  font-weight: 700;
  cursor: pointer;
}

.pad .dial-pad .digits .dig.clicked {
  animation: pulse-gray linear 0.5s 1;
}

.pad .dial-pad .digits .dig:nth-child(3n-1) {
  margin: 10px calc(50% - 90px);
}

.pad .dial-pad .digits .dig.astrisk {
  padding-top: 17px;
  height: 43px;
}

.pad .dial-pad .digits .dig.pound {
  padding-top: 10px;
  height: 50px;
}

.pad .dial-pad .digits .dig .sub-dig {
  font-size: 8px;
  font-weight: 300;
  position: relative;
  top: -2px;
}

.pad .dial-pad .digits .dig.addPerson,
.pad .dial-pad .digits .dig.goBack {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 55% auto;
  margin-bottom: 25px;
  box-shadow: 0px 25px 30px -15px black;
}

.pad .dial-pad .digits .dig.addPerson {
  background-color: #285efa;
  background-image: url(https://s16.postimg.org/4u2rbu85t/add_Person.png);
}

.pad .dial-pad .digits .dig.addPerson.clicked {
  animation: pulse-blue linear 0.5s 1;
}

.pad .dial-pad .digits .dig.goBack {
  background-color: #fa4a5d;
  background-image: url(https://s4.postimg.org/x6g6auu7d/back_Arrow.png);
}

.pad .dial-pad .digits .dig.goBack.clicked {
  animation: pulse-red linear 0.5s 1;
}

.pad .call-pad {
  opacity: 0;
  height: 0px;
  pointer-events: none;
  background-image: url(https://s21.postimg.org/x4te7wpo7/call_Background.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  transition: opacity 0.3s ease;
  position: absolute;
  width: 100%;
  left: 0px;
  top: 0px;
  transition: opacity 0.3s ease;
}

.pad .call-pad.in-call {
  height: 100%;
  opacity: 1;
  pointer-events: all;
}

.pad .call-pad .pulsate {
  opacity: 0;
  width: 150px;
  height: 0px;
  overflow: visible;
  position: relative;
  display: block;
  margin: 0 auto 0;
  top: 120px;
  transition: opacity 0.5s ease;
}

.pad .call-pad .pulsate.active-call {
  animation: pulsator 2s ease infinite;
  opacity: 1;
}

.pad .call-pad .pulsate div {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.06);
  border-radius: 100%;
  margin: auto;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.pad .call-pad .pulsate div:nth-child(1) {
  width: 110px;
  height: 110px;
}

.pad .call-pad .pulsate div:nth-child(2) {
  width: 122px;
  height: 122px;
}

.pad .call-pad .pulsate div:nth-child(3) {
  width: 134px;
  height: 134px;
}

.pad .call-pad .ca-avatar {
  width: 100px;
  height: 100px;
  margin: 70px auto;
  margin-bottom: 30px;
  display: block;
  background-color: #111111;
  border-radius: 100%;
  box-shadow: 0px 20px 25px -10px rgba(0, 0, 0, 0.8);
  background-position: center center;
  background-size: 100% auto;
  background-repeat: no-repeat;
  transition: opacity 1s ease, transform 1s ease;
  opacity: 0.5;
  transform: scale(0.5, 0.5);
}

.pad .call-pad .ca-avatar.in-call {
  transform: scale(1, 1);
  opacity: 1;
}

.pad .call-pad .ca-name,
.pad .call-pad .ca-number,
.pad .call-pad .ca-status {
  width: 60%;
  margin-left: 20%;
  color: white;
  text-align: center;
  font-weight: bold;
  margin-bottom: 15px;
}

.pad .call-pad .ca-name {
  font-size: 18px;
}

.pad .call-pad .ca-number {
  font-size: 28px;
  letter-spacing: 2px;
}

.pad .call-pad .ca-status {
  font-size: 30px;
  margin-top: 40px;
  margin-bottom: 40px;
}

.pad .call-pad .ca-status:after {
  content: attr(data-dots);
  position: absolute;
}

.pad .call-pad .ca-buttons {
  width: 70%;
  margin-left: 15%;
}

.pad .call-pad .ca-buttons .ca-b-single {
  float: left;
  width: 60px;
  height: 60px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 100%;
  position: relative;
  margin-bottom: 40px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 55% auto;
}

.pad .call-pad .ca-buttons .ca-b-single:nth-child(3n-1) {
  margin-left: calc(100% - 230px);
  margin-right: calc(100% - 230px);
}

.pad .call-pad .ca-buttons .ca-b-single:after {
  content: attr(data-label);
  color: white;
  position: absolute;
  text-align: center;
  font-size: 10px;
  width: 100px;
  bottom: -20px;
  left: -18px;
  letter-spacing: 2px;
}

.call {
  color: white;
  font-size: 30px;
  text-align: center;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  margin: 10px 0px;
  font-weight: 700;
  cursor: pointer;
  position: absolute;
  left: calc(50% - 30px);
  bottom: 25px;
  box-shadow: 0px 25px 30px -15px black;
  background-color: #3de066;
}

.call .call-icon {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-size: 60% auto;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url(https://s13.postimg.org/sqno4q8sj/call.png);
  transition: transform 0.3s ease;
}

.call .call-icon.in-call {
  -ms-transform: rotate(134deg);
  -webkit-transform: rotate(134deg);
  transform: rotate(134deg);
}

.call .call-change {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  overflow: hidden;
}

.call .call-change span {
  width: 70px;
  height: 67px;
  display: block;
  background-color: #fa4a5d;
  position: relative;
  top: 70px;
  left: 70px;
  border-radius: 100%;
  transition: left 0.3s ease, top 0.3s ease;
}

.call .call-change.in-call span {
  top: -5px;
  left: -5px;
}

.call.clicked {
  animation: pulse-green linear 0.5s 1 forwards;
}

@keyframes pulse-gray {
  0% {
    box-shadow: inset 0 0 0px 30px #2d2d2d, inset 0 0 0px 30px white;
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }

  10% {
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  30% {
    box-shadow: inset 0 0 0px 10px #2d2d2d, inset 0 0 0px 30px white;
  }

  60% {
    box-shadow: inset 0 0 0px 0px #2d2d2d, inset 0 0 0px 0px white;
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  100% {
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@keyframes pulse-blue {
  0% {
    box-shadow: inset 0 0 0px 30px #285efa, inset 0 0 0px 30px white;
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }

  10% {
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  30% {
    box-shadow: inset 0 0 0px 10px #285efa, inset 0 0 0px 30px white;
  }

  60% {
    box-shadow: inset 0 0 0px 0px #285efa, inset 0 0 0px 0px white;
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  100% {
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@keyframes pulse-green {
  0% {
    box-shadow: inset 0 0 0px 30px #3de066, inset 0 0 0px 30px white;
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }

  10% {
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  30% {
    box-shadow: inset 0 0 0px 10px #3de066, inset 0 0 0px 30px white;
  }

  60% {
    box-shadow: inset 0 0 0px 0px #3de066, inset 0 0 0px 0px white;
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  100% {
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@keyframes pulse-red {
  0% {
    box-shadow: inset 0 0 0px 30px #fa4a5d, inset 0 0 0px 30px white;
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }

  10% {
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  30% {
    box-shadow: inset 0 0 0px 10px #fa4a5d, inset 0 0 0px 30px white;
  }

  60% {
    box-shadow: inset 0 0 0px 0px #fa4a5d, inset 0 0 0px 0px white;
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  100% {
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@keyframes pulsator {
  0% {
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }

  40% {
    -ms-transform: scale(0.8, 0.8);
    -webkit-transform: scale(0.8, 0.8);
    transform: scale(0.8, 0.8);
  }

  100% {
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@keyframes showPad {
  0% {
    top: 50px;
    opacity: 0;
  }

  100% {
    top: 0px;
    opacity: 1;
  }
}

p {
  position: fixed;
  bottom: 0px;
  left: 15px;
  color: white;
  font-family: Lato;
  font-weight: 300;
  overflow: hidden;
}

p a:link,
p a:visited {
  color: white;
}

p a:hover {
  opacity: 0.5;
}

p img {
  width: 20px;
  height: 20px;
  position: relative;
  top: 6px;
}
</style>
